import React from 'react'
import CV from '../../assets/Joao_Victor_Liz_Full_Stack_Developer_Att.pdf'
import CVPT from '../../assets/Joao_Victor_Liz_Full_Stack_Developer_PT.pdf'
import { useTranslation } from "react-i18next";


const CTA = () => {

  const { t, i18n  } = useTranslation();
  
  return (
    <div className='cta'>
      <a href={i18n.language === "en" ? CV : CVPT} download className='btn'>{t("cv")}</a>
      <a href="#contact" className='btn btn-primary' >{t("lets")}</a>
    </div>
  )
}

export default CTA